import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyDigitalFormsFormUnableToFetchSvg = lazy(
  () => import('./svg-components/digital-forms-form-unable-to-fetch-svg')
);

const DigitalFormsFormUnableToFetchSvg = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyDigitalFormsFormUnableToFetchSvg {...rest} />
  </Suspense>
);

export default DigitalFormsFormUnableToFetchSvg;
